import 'loadjs';
import Alpine from 'alpinejs'
import 'lazysizes';
import '../css/config.scss'

window.Alpine = Alpine

Alpine.start()
